import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { DocumentTitle } from '@maui-mf/root/DocumentTitle'
import routes from './routes'
import { loggedInAuth, loggedOutAuth } from './authStates'
import { translate } from '../utils'
import { useAuthContext } from '../AuthContext'
import { useClearNotifications } from '../store/notifications'
import { LoginRedirect } from './LoginRedirect'
import { Error } from '../common/Errors'

export default function AppRoute({
  component: Component,
  children,
  name,
  authState = loggedInAuth,
  maAdminRoles,
  orgAdminRoles,
  role,
  roles,
  orgRoles,
  entitlements,
  unentitledRedirect,
  ...props
}) {
  const {
    hasEntitlements,
    hasDTMLicenses,
    hasMaAdminRoles,
    hasRole,
    hasOrgRoles,
    hasVulnAccess,
    isLoggedIn,
    returnTo,
  } = useAuthContext()

  // clear the notifications on mount
  useClearNotifications()

  if (isLoggedIn && authState === loggedOutAuth) {
    // Attempting to hit a logged out page, redirecting...
    //
    // NOTE This is how the app routes handle redirecting from the SSO token
    //      retrieval route (hence the returnTo). The MF auth app has its own
    //      returnTo handling so this doesn't really apply.  "returnTo" from
    //      the MF auth context is presently just returning "/" (in the case
    //      where a user tries to nav to a "logged out only" page manually)
    return <Redirect to={returnTo} />
  }

  // Campaigns feature flagged for now
  if (props.hasFeature === 0) {
    return <Error errorCode="404"/>
  }

  if (!isLoggedIn && authState === loggedInAuth) {
    return <LoginRedirect />
  }

  if (role && !hasRole(role)) {
    return <Error errorCode="403" />
  }

  if (orgRoles && !hasOrgRoles(orgRoles)) {
    return <Error errorCode="403" />
  }

  if (maAdminRoles && !hasMaAdminRoles(maAdminRoles)) {
    return <Error errorCode="403"/>
  }

  if (entitlements && !hasEntitlements(entitlements)) {
    return <Redirect to={unentitledRedirect || routes.upgrade()} />
  }

  // Main page is determined by the user entitlements
  if (name === 'dashboard') {
    // Vuln only users home page
    if (hasVulnAccess && !hasEntitlements(['INTEL_RBI_FUS', 'INTEL_RBI_OPS', 'INTEL_DTM_STNDRD'])) {
      return <Redirect to="/vulnerabilities" />
    }
    // DTM only users home page
    if (hasDTMLicenses && !hasEntitlements(['INTEL_RBI_FUS', 'INTEL_RBI_OPS'])) {
      return <Redirect to="/dtm" />
    }
  }

  return (
    <Route {...props}>
      <DocumentTitle>
        {translate(['routes', name, 'title'])}
      </DocumentTitle>
      {Component ? <Component /> : children}
    </Route>
  )
}
